import { LOCALE_CHANGED } from '../../constants'
import getAttributesImport from '../../settings/attributes'
import { actions as backendActions, selectors as backendSelectors } from '../Backend'
import { selectors as commonTextsSelectors } from '../CommonTexts'

export { default as getTexts } from '../../store/localizer'

export const getAttributes = (locale) => {
    const attributes = getAttributesImport(locale)
    return {
        languages: attributes.languages,
        apiPermissionsLink: attributes.link.apiPermissions,
    }
}

export { default as Button } from '../../components/Button'
export { default as Tooltip } from '../../containers/Tooltip'
export { launcherOpenCacheDialog, launcherOpenUrl } from '../../launcherBackend/launcher-command'

export const actions = {
    setDownloadEverything: backendActions.setDownloadEverything,
    setRunClientsWithLogging: backendActions.setRunClientsWithLogging,
    setRunClientsWithDx9: backendActions.setRunClientsWithDx9,
    setShouldMinimizeToTray: backendActions.setShouldMinimizeToTray,
    setLocale: backendActions.setLocale,
    setTestServers: backendActions.setTestServers,
}

export const constants = {
    LOCALE_CHANGED,
}

export const selectors = {
    getDownloadEverything: state => backendSelectors.getDownloadEverything(state),
    getRunClientsWithLogging: state => backendSelectors.getRunClientsWithLogging(state),
    getRunClientsWithDx9: state => backendSelectors.getRunClientsWithDx9(state),
    getShouldMinimizeToTray: state => backendSelectors.getShouldMinimizeToTray(state),
    getLocale: state => backendSelectors.getLocale(state),
    getDefaultServer: state => backendSelectors.getDefaultServer(backendSelectors.getLocale(state)),
    getSimplifiedServers: state => backendSelectors.getSimplifiedServers(state),
    getTestServers: state => backendSelectors.getTestServers(state),
    getExternalLinkText: state => commonTextsSelectors.getAttentionText(state),
}



// WEBPACK FOOTER //
// ./src/features/Settings/imports.js